/* globals setInterval clearInterval */
angular.module("digiexam.components").directive("onHeightResize", function onHeightResize($parse) {
	"use strict";
	var intervalId = null;
	function cleanup() {
		return clearInterval(intervalId);
	}

	return {
		restrict: "A",
		link: function link(scope, element, attrs) {
			var model = $parse(attrs.onHeightResize);
			var height = model(scope);
			function heightResizePoller() {
				var h = element.innerHeight();
				if (h !== height) {
					height = parseInt(h, 10);
					scope.$apply(function apply() {
						model.assign(scope, height);
					});
				}
			}

			// Using a normal setInterval here as using $timeout triggers a $digest
			// eslint-disable-next-line angular/interval-service
			intervalId = setInterval(heightResizePoller, 100);
		},
		controller: function controller($scope) {
			return $scope.$on("$destroy", cleanup);
		},
	};
});
